import React from 'react';
import { graphql } from 'react-apollo';
import Banner from '../../../../components/Banner/index';
import Footer from '../../../../components/Footer/index';
import Form from '../Form';
import CREATE_USER_MUTATION from '../../../../graphql/CreateUser';
import { IsAdmin } from '../../../../utils/Roles';

class CreateUser extends React.Component {
  componentWillMount() {
    if (!IsAdmin()) {
      this.props.history.push('/login');
    }
  }

  handleUserCreation = (user) => {
    const { mutate, history } = this.props;

    mutate({
      variables: user,
    })
      .then((res) => {
        history.push('/admin/users');
      })
      .catch((err) => {
        console.error(err);
      });
  };

  render() {
    return (
      <div>
        <Banner />
        <div className="properties-details-page">
          <div className="container">
            <div className="row">
              <div className="col-md-1" />
              <div className="col-md-10 new-form-container">
                <div className="submit-address">
                  <Form
                    title="Nuevo usuario"
                    onSubmit={this.handleUserCreation}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const withMutation = graphql(CREATE_USER_MUTATION);

export default withMutation(CreateUser);



// WEBPACK FOOTER //
// ./src/containers/Admin/User/Create/index.js